module.exports = __webpack_public_path__ + "assets/img/contact-b.3985fc46.png";